var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{ref:"select",attrs:{"options":_vm.options,"label":"text"},on:{"change":function (val) { return _vm.$emit('input', val); }},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42e9422e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Form/CountrySelect.vue
// module id = xgSq
// module chunks = 1